export interface AdobeResponse {
  result: string;
}
